/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {legacyGetMerchant} from '../api'

export const useMutationLegacyGetMerchant = createReactQueryMutationHook('legacyGetMerchant', legacyGetMerchant)
